'use client'

import * as Headless from '@headlessui/react'
import React, { forwardRef } from 'react'
import { Link as RouterDomLink, LinkProps as RouterDomLinkProps } from 'react-router-dom'

export type CustomLinkProps = Omit<RouterDomLinkProps, 'ref'> & {
  // Add any custom props if needed
};

export const Link = forwardRef<HTMLAnchorElement, CustomLinkProps>(
  function Link(props, ref) {
    return (
      <Headless.DataInteractive>
        <RouterDomLink {...props} ref={ref} />
      </Headless.DataInteractive>
    )
  }
)